if (typeof document !== 'undefined' && !document.head.querySelector("style[data-wp-hash='0ef177d148']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "0ef177d148");
	style.appendChild(document.createTextNode(".boot-save-button{width:100%}"));
	document.head.appendChild(style);
}
